import { AxiosResponse } from 'axios';
import { SET_WEEKLY_EVENTS, SET_WEEKLY_EVENT, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_WEEKLY_EVENT_ISLOADING,
  DELETE_WEEKLY_EVENT,
  EDIT_WEEKLY_EVENT,
  GET_WEEKLY_EVENT,
  GET_WEEKLY_EVENTS,
  REGISTER_WEEKLY_EVENT,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import WeeklyEvent from '@/services/weekly_event';
import { Module } from 'vuex';
import { EditWeeklyEvent, RegisterWeeklyEvent, GetWeeklyEvent } from '@/dtos/weekly_event.dto';

const weeklyEvent: Module<any, {}> = {
  state: {
    weeklyEvent: {
      data: null,
      isLoading: false,
    },
    weeklyEvents: {
      data: null,
      metaData: null,
      isLoading: false,
    },
  },
  getters: {
    weeklyEvent: (state: { weeklyEvent: any }) => state.weeklyEvent,
    weeklyEvents: (state: { weeklyEvents: any }) => state.weeklyEvents,
  },
  mutations: {
    [SET_WEEKLY_EVENT]: (
      state: { weeklyEvent: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.weeklyEvent.data = payload.data) : null,
        (state.weeklyEvent.isLoading = payload.isLoading);
    },
    [SET_WEEKLY_EVENTS]: (
      state: { weeklyEvents: StateObject },
      payload: { data: null; metaData: any; isLoading: any }
    ) => {
      payload.data != null ? (state.weeklyEvents.data = payload.data) : null,
      payload.metaData != null
          ? (state.weeklyEvents.metaData = payload.metaData)
          : null,
        (state.weeklyEvents.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_WEEKLY_EVENT]: async ({ commit }: any, payload: RegisterWeeklyEvent) => {
      commit(SET_WEEKLY_EVENT, { data: null, isLoading: true });

      const result: AxiosResponse = await WeeklyEvent.registerWeeklyEvent(
        payload
      );

      if (result) {
        if (result.data.status) {
          commit(SET_WEEKLY_EVENT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_WEEKLY_EVENT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_WEEKLY_EVENT, { isLoading: false });
        return false;
      }
    },
    [GET_WEEKLY_EVENTS]: async ({ commit }: any, payload: any) => {
      commit(SET_WEEKLY_EVENTS, { data: null, isLoading: true });

      const result: AxiosResponse = await WeeklyEvent.getWeeklyEvents(
        payload as GetWeeklyEvent
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_WEEKLY_EVENTS, { data: result.data.data, metaData: result.data.metaData, isLoading: false });
          return true;
        }
        commit(SET_WEEKLY_EVENTS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_WEEKLY_EVENTS, { isLoading: false });
        return false;
      }
    },
    [GET_WEEKLY_EVENT]: async ({ commit }: any, payload: any) => {
      commit(SET_WEEKLY_EVENT, { data: null, isLoading: true });

      const result: AxiosResponse = await WeeklyEvent.getWeeklyEvents(
        payload as GetWeeklyEvent
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_WEEKLY_EVENT, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_WEEKLY_EVENT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_WEEKLY_EVENT, { isLoading: false });
        return false;
      }
    },
    [EDIT_WEEKLY_EVENT]: async ({ commit }: any, payload: EditWeeklyEvent) => {
      commit(SET_WEEKLY_EVENT, { data: null, isLoading: true });

      const result: AxiosResponse = await WeeklyEvent.editWeeklyEvent(
        payload
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_WEEKLY_EVENT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_WEEKLY_EVENT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_WEEKLY_EVENT, { isLoading: false });
        return false;
      }
    },
    [DELETE_WEEKLY_EVENT]: async ({ commit }: any, payload: string) => {
      commit(SET_WEEKLY_EVENT, { data: null, isLoading: true });

      const result: AxiosResponse = await WeeklyEvent.deleteWeeklyEvent(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_WEEKLY_EVENT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_WEEKLY_EVENT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_WEEKLY_EVENT, { isLoading: false });
        return false;
      }
    },
    [CLEAR_WEEKLY_EVENT_ISLOADING]: ({ commit }) => {
      commit(SET_WEEKLY_EVENT, { isLoading: false });
      commit(SET_WEEKLY_EVENTS, { isLoading: false });
    },
  },
};

export default weeklyEvent;

